import { render, staticRenderFns } from "./SliderNavigation.vue?vue&type=template&id=25fd0368"
import script from "./SliderNavigation.vue?vue&type=script&lang=js"
export * from "./SliderNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports